export default {
  "UNPAID": "未支付",
  "PAID": "已支付",
  "SUBMITTED": "待提交",
  "PENDING": "待审核",
  "VERIFIED": "审核通过",
  "REJECTED": "未通过",
  "CANCELED": "已取消",
  "DISABLED": "已失效",
  "PENDING_PAY": "部分支付",

  "GENERAL": "租赁",
  "FEEITEM": "费用项",
  "EDITPRICE": "改价项",
  "DISCOUNT": "折扣行",
  "REFUND": "退款项",
  "DEDUCTION": "扣费项",
  "COUPON": "抵扣",


  "REFUNDING": "待退款",
  "REFUNDED": "已退款",
  "COMPLETED": "已完成",
  "FINISH": "已处理",
  "IN_PROCESS": "处理中",


  '基础版': '基础版',
  '升级版': '升级版',
  '豪华版': '豪华版',

  'EXPORTED': '已导出',
  'UNEXPORTED': '可导出',
  'APPLYED': '已申请',

  'UP_PC': '网银支付',
  'CASH': '现金刷卡',
  'BALANCE': '余额支付',
  'REMITTANCE': '转账汇款',
  'CLOUDBILL': '云账单支付',
  'WX_MP': '小程序微信支付',
  'WX_QR': '微信支付',
  'ALI_PC': '支付宝支付',
  'WX_BC': '微信扫码支付',
  'ALI_BC': '支付宝扫码支付',
  'ALI_H5': '支付宝H5支付',
  'WX_H5': '微信H5支付',
  'ON_SITE': '现场支付',
  '未选择支付方式': '未选择支付方式',

  'NOT_SEND': '未派送',
  'HAVE_ACCEPTED': '已受理',
  'HAVE_SEND': '已派送',

  'LOCAL': '本地车证',
  'NOLOCAL': '外埠车证',

}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/dataI18n/status.js